module.exports = __webpack_public_path__ + "static/media/detail_0037_t.95f39abf.jpg";